import { DependencyList, forwardRef, JSX, useEffect } from 'react';
import { Tooltip as ReactTooltip, ITooltip, TooltipRefProps } from 'react-tooltip';
import classNames from 'classnames';
import classes from './Tooltip.module.scss';

interface ICustomTooltip extends ITooltip {
    duration?: number;
    onTimeout?(): void;
    opacity?: ITooltip['opacity'];
    deps?: DependencyList;
    dataQa?: string;
}

export const Tooltip = forwardRef<TooltipRefProps, ICustomTooltip>(
    ({ opacity = 0.9, deps = [], ...props }, ref): JSX.Element => {
        useEffect(() => {
            // only run this when component is controlled and is not open, so timeout won't be executed on component mount
            if (!props.duration || !props.onTimeout || props.isOpen === false) {
                return undefined;
            }

            const timeout = setTimeout(props.onTimeout, props.duration);

            return () => {
                clearTimeout(timeout);
            };
        }, [props.duration, props.isOpen, ...deps]);

        return (
            <ReactTooltip
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...props}
                ref={ref}
                opacity={opacity}
                className={classNames(classes.container, props.className, {
                    [classes.isClosed]: !props.isOpen,
                })}
                classNameArrow={classNames(classes.arrow, props.classNameArrow)}
                data-qa={props.dataQa}
            >
                {props.children}
            </ReactTooltip>
        );
    },
);
